<template>
  <section>
    <base-card>
      <h2>Page not found</h2>
      <p>
        This page could not be found. You can check the list of
        <router-link to="/coaches">coches.</router-link>
      </p>
    </base-card>
  </section>
</template>